import { Link } from 'react-router-dom';

/**
 * EntrepreNatives text logo with rainbow holographic effect
 * No icon — just the text, clean and centered
 */
export function ENLogo({ size = 'md', linkTo = '/', className = '' }) {
  const textSize = size === 'sm' ? 'text-base' : size === 'lg' ? 'text-xl' : size === 'xl' ? 'text-2xl' : 'text-lg';

  const content = (
    <div className={`flex items-center ${className}`} data-testid="en-logo">
      <span className={`text-holographic font-bold tracking-tight font-syne ${textSize}`}>
        ENTREPRENATIVES
      </span>
    </div>
  );

  if (linkTo) {
    return <Link to={linkTo}>{content}</Link>;
  }
  return content;
}

/**
 * Standalone EN icon - kept for cases where just an icon is needed
 */
export function ENIcon({ size = 40, className = '' }) {
  return (
    <div className={`relative flex-shrink-0 ${className}`} style={{ width: size, height: size }} data-testid="en-icon">
      <img src="/assets/en-logo.png" alt="EN" className="w-full h-full object-contain" style={{ filter: 'brightness(0) invert(1)' }} />
      <div className="absolute inset-0 en-logo-rainbow-overlay" style={{ mixBlendMode: 'color', WebkitMaskImage: `url(/assets/en-logo.png)`, WebkitMaskSize: 'contain', WebkitMaskRepeat: 'no-repeat', WebkitMaskPosition: 'center', maskImage: `url(/assets/en-logo.png)`, maskSize: 'contain', maskRepeat: 'no-repeat', maskPosition: 'center' }} />
    </div>
  );
}
